import React from 'react'
import Avatar from 'react-avatar';
export function ImageViewer(props){
    return(
        props.picture ?<img src={props.picture} width={props.size} height={props.size} /> :<Avatar name={props.name} size={props.size} round={true}/> 
    )
}